<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card card-custom gutter-b card-stretch">
          <!--begin::Header-->
          <div class="card-header border-0">
            <h3 class="card-title font-weight-bolder text-dark">{{$t('user_detail.invite')}}</h3>
            <div class="card-toolbar">
              <b-button-group>
                <b-button size="sm"><i class="far fa-file-excel mr-2"></i> Excel'e Aktar</b-button>
                <b-button size="sm"><i class="fas fa-sync mr-2"></i> Listeyi Yenile</b-button>
              </b-button-group>
            </div>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body pt-2">
            <div class="row">
              <div class="offset-8 col-md-4">
                <b-input-group class="mt-3 mb-4" size="sm">
                  <b-form-input></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary"><i class="fa fa-search"></i> Ara</b-button>
                  </b-input-group-append>
                </b-input-group>
              </div>
              <div class="col-md-12">
                <data-table
                    :items="table.items"
                    :fields="report.fields"
                    :paginate="report.paginate"
                    :responsive="table.responsive"
                    page.sync="3"
                    perPage.sync="10"
                ></data-table>
              </div>
            </div>
          </div>
          <!--end::Body-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";

export default {
  name: "Invitation",
  components: {DataTable},
  data() {
    return {
      form : {
      },
      table : {
        responsive : true,
        items : [
          {'member_id' : '3871304', 'firstname' : 'Serdar', 'lastname' : 'Mermer', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com',},
          {'member_id' : '3871305', 'firstname' : 'Utku', 'lastname' : 'Kurtkulağı', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com',},
          {'member_id' : '3871306', 'firstname' : 'Burcu', 'lastname' : 'Müfit', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com',},
          {'member_id' : '3871307', 'firstname' : 'Hüsniye', 'lastname' : 'Tutar', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com',},
          {'member_id' : '3871308', 'firstname' : 'Rıza', 'lastname' : 'Bel', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com',},
          {'member_id' : '3871309', 'firstname' : 'Ali', 'lastname' : 'Evren', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com',},
          {'member_id' : '3871310', 'firstname' : 'Emre', 'lastname' : 'Duran', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com',},
          {'member_id' : '3871311', 'firstname' : 'Elmas', 'lastname' : 'Yıldız', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com',},
          {'member_id' : '3871312', 'firstname' : 'Hamit', 'lastname' : 'Can', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com',},
          {'member_id' : '3871313', 'firstname' : 'Müge', 'lastname' : 'Ateş', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com',},
          {'member_id' : '3871314', 'firstname' : 'Oğuz', 'lastname' : 'Aslan', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com',},
          {'member_id' : '3871315', 'firstname' : 'Sinan', 'lastname' : 'Yıldırım', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com',},
          {'member_id' : '3871316', 'firstname' : 'Büşra', 'lastname' : 'Demir', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com',},
          {'member_id' : '3871317', 'firstname' : 'Yelda', 'lastname' : 'Özbakır', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com',},
          {'member_id' : '3871318', 'firstname' : 'Rüzgar', 'lastname' : 'Kanca', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com',},
          {'member_id' : '3871319', 'firstname' : 'Murat', 'lastname' : 'Toptan', 'register_date' : '12.12.2020 13:56', 'email' : 'test@test.com',},
        ],
      },
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 10,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        fields: [
          {key: 'member_id', label: 'Member ID', sortable: false},
          {key: 'firstname', label: 'Ad', sortable: true},
          {key: 'lastname', label: 'Soyad', sortable: true},
          {key: 'email', label: 'E-Posta', sortable: true},
          {key: 'email_confirm', label: 'Email Onayı', sortable: true},
          {key: 'sms_confirm', label: 'SMS Onayı', sortable: true},
          {key: 'register_date', label: 'Kayıt Tarihi', sortable: true},
        ],
      },
    }
  },
};
</script>
